import { render, staticRenderFns } from "./HeadMember.vue?vue&type=template&id=55551cb6&scoped=true"
import script from "./HeadMember.vue?vue&type=script&lang=js"
export * from "./HeadMember.vue?vue&type=script&lang=js"
import style0 from "./HeadMember.vue?vue&type=style&index=0&id=55551cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55551cb6",
  null
  
)

export default component.exports